export const TETRIS_AVAILABILITY_PREFERENCE_KEYS = {
  preferAvailability: 'dororaid:tetris:prefer-availability',
  currentOnly: 'dororaid:tetris:current-availability-only',
};

function readStoredFlag(storageKey) {
  if (typeof window === 'undefined') return false;
  try { return window.localStorage.getItem(storageKey) === '1'; } catch { return false; }
}

export function readTetrisAvailabilityPreferences() {
  return {
    preferAvailability: readStoredFlag(TETRIS_AVAILABILITY_PREFERENCE_KEYS.preferAvailability),
    currentOnly: readStoredFlag(TETRIS_AVAILABILITY_PREFERENCE_KEYS.currentOnly),
  };
}

export function writeTetrisAvailabilityPreference(key, checked) {
  const storageKey = TETRIS_AVAILABILITY_PREFERENCE_KEYS[key];
  if (!storageKey || typeof window === 'undefined') return;
  try { window.localStorage.setItem(storageKey, checked ? '1' : '0'); } catch { /* storage unavailable */ }
}
